import {
  doc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Set_thumbnail = async (data) => {
  const { uid,thumbnail } = data || {};

  // 1. Validate inputs
  if (!uid?.trim()) {
    return { success: false, error: "Missing uid for update." };
  }
  if (!thumbnail?.trim()) {
    return { success: false, error: "Missing thumbnail" };
  }
  
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || sessiontoken === "undefined") {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid || guid === "undefined") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
      const tablename = "products";

    // ✅ Verify record exists for this uid & guid
    const productQuery = query(
      collection(db, tablename),
      where("uid", "==", uid),
      where("guid", "==", guid)
    );    
    const productSnap = await getDocs(productQuery);
    if (productSnap.empty) {
      // Product already exists
      return { success: false, error: "This product not exists." };
    }

    // Product doesn't exist, create new
 
    const savedata = {
      thumbnail, 
      date_time_thumbnail: new Date(),
    };

    const productRef = doc(collection(db, tablename), uid);
    await setDoc(productRef, savedata,{merge:true});

    return { success: true, dockuid: uid, message: "Product saved successfully." };

  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
